import React from "react";

function PendingIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6870_3562)">
        <path
          d="M13.1641 22.9219C7.37406 22.9219 2.66406 18.2119 2.66406 12.4219C2.66406 6.63188 7.37406 1.92188 13.1641 1.92188C18.9541 1.92188 23.6641 6.63188 23.6641 12.4219C23.6641 18.2119 18.9541 22.9219 13.1641 22.9219ZM13.1641 3.42188C8.19906 3.42188 4.16406 7.45687 4.16406 12.4219C4.16406 17.3869 8.19906 21.4219 13.1641 21.4219C18.1291 21.4219 22.1641 17.3869 22.1641 12.4219C22.1641 7.45687 18.1291 3.42188 13.1641 3.42188Z"
          fill="#854D0E"
        />
        <path
          d="M16.1641 16.1719C16.0291 16.1719 15.8941 16.1419 15.7741 16.0669L12.0241 13.8169C11.9135 13.7496 11.8222 13.6548 11.7592 13.5418C11.6961 13.4287 11.6633 13.3013 11.6641 13.1719V7.17188C11.6641 6.75187 11.9941 6.42188 12.4141 6.42188C12.8341 6.42188 13.1641 6.75187 13.1641 7.17188V12.7519L16.5541 14.7769C16.6937 14.8625 16.8016 14.9912 16.8615 15.1437C16.9213 15.2961 16.9299 15.4639 16.8858 15.6216C16.8417 15.7793 16.7474 15.9184 16.6171 16.0177C16.4869 16.117 16.3278 16.1711 16.1641 16.1719Z"
          fill="#854D0E"
        />
      </g>
      <defs>
        <clipPath id="clip0_6870_3562">
          <rect width="25.6709" height="25.6709" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default PendingIcon;
